import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableCellDefaultVariants = {
  "size": "md",
  "cellType": "basic",
  "align": "left",
  "state": "default",
  "isEditable": false,
  "showCellFocus": true,
  "showRightLine": true
}
const tableCellCompoundVariants = [
  {
    "state": "focus",
    "isEditable": true,
    "css": {
      "container": {
        "backgroundColor": "neutral.surface.low"
      }
    }
  }
]

const tableCellSlotNames = [
  [
    "root",
    "table-cell__root"
  ],
  [
    "container",
    "table-cell__container"
  ],
  [
    "itemWrapper",
    "table-cell__itemWrapper"
  ],
  [
    "rightLine",
    "table-cell__rightLine"
  ],
  [
    "indexNumber",
    "table-cell__indexNumber"
  ],
  [
    "indexControls",
    "table-cell__indexControls"
  ]
]
const tableCellSlotFns = /* @__PURE__ */ tableCellSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableCellDefaultVariants, getSlotCompoundVariant(tableCellCompoundVariants, slotName))])

const tableCellFn = memo((props = {}) => {
  return Object.fromEntries(tableCellSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableCellVariantKeys = [
  "size",
  "cellType",
  "align",
  "state",
  "isEditable",
  "showCellFocus",
  "showRightLine"
]
const getVariantProps = (variants) => ({ ...tableCellDefaultVariants, ...compact(variants) })

export const tableCell = /* @__PURE__ */ Object.assign(tableCellFn, {
  __recipe__: false,
  __name__: 'tableCell',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableCellVariantKeys,
  variantMap: {
  "size": [
    "md",
    "sm"
  ],
  "cellType": [
    "utility",
    "basic"
  ],
  "align": [
    "left",
    "center",
    "right"
  ],
  "state": [
    "default",
    "focus",
    "focusActive"
  ],
  "isEditable": [
    "true",
    "false"
  ],
  "showCellFocus": [
    "true",
    "false"
  ],
  "showRightLine": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableCellVariantKeys)
  },
  getVariantProps
})